import {
  getBoundingBox,
  Point,
  Resolution,
  translateBox,
} from "@/features/Editor/Canvas/canvas-geometry";
import type { CanvasElement } from "./canvas-state";
import type { GestureOutput } from "./canvas-gesture";
import { getGuidelines, getSnapTargets } from "./canvas-snapping";

// Moving the selection with the arrow keys. Returns null when nothing selected is visible.
export function createNudge(
  canvasElements: CanvasElement[],
  selectedIds: string[],
  resolution: Resolution,
) {
  const nudgingElements = canvasElements.filter(({ externalId }) =>
    selectedIds.includes(externalId),
  );
  const selectionBox = getBoundingBox(nudgingElements.map(({ box }) => box));

  if (!selectionBox) {
    return null;
  }

  const snapTargets = getSnapTargets(
    canvasElements
      .filter((element) => !nudgingElements.includes(element))
      .map(({ box }) => box),
    resolution,
  );

  return (offset: Point): GestureOutput => ({
    drafts: Object.fromEntries(
      nudgingElements.map(({ externalId, box }) => [
        externalId,
        translateBox(box, offset.x, offset.y),
      ]),
    ),
    guidelines: getGuidelines(
      translateBox(selectionBox, offset.x, offset.y),
      snapTargets,
    ),
  });
}
